import useBowlingCentersStore from '@/shared/store/bowlingCenters';

import BcCard from './bcCard';

const RecentlyViewed = () => {
  const { recents } = useBowlingCentersStore();

  if (recents?.length === 0) return null;

  return (
    <section className="flex flex-col p-5 w-full bg-black bg-opacity-30 max-md:max-w-full mt-4">
      <h2 className="text-lg font-semibold tracking-wider leading-6 text-green-400 max-md:max-w-full">
        Recently viewed
      </h2>
      <ul>
        {recents.map((center) => (
          <li
            key={center.uuid}
            className="border-b border-solid border-neutral-700/60 last:border-b-0"
          >
            <BcCard data={center} />
          </li>
        ))}
      </ul>
    </section>
  );
};

export default RecentlyViewed;
